<template>
  <a-base-component :subscribed_modules="subscribed_modules">
    <template v-slot:default>
      <div
        class="a-rms-strategy-weeks-header d-flex justify-space-between align-center mb-3 w-100"
        style="margin-top: 8px;"
      >
        <div class="d-flex align-center" style="gap: 5px">
          <a-display-options-container>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="density === 'default' ? 'secondary' : 'grey'"
                  :class="density === 'default' ? 'active' : ''"
                  @click="setDensity('default')"
                >
                  mdi-server-outline
                </v-icon>
              </template>
              <span>{{ $t("expanded") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="density === 'compact' ? 'secondary' : 'grey'"
                  :class="density === 'compact' ? 'active' : ''"
                  @click="setDensity('compact')"
                >
                  mdi-format-align-justify
                </v-icon>
              </template>
              <span>{{ $t("compact") }}</span>
            </v-tooltip>
          </a-display-options-container>
          <a-rms-vs-selector-single
            ref="a-rms-vs-selector-single"
            :value_vs="strategy_vs_spot"
            class="elevation-1 rounded-pill"
            hide_pickup
            @updateVs="updateVs"
          ></a-rms-vs-selector-single>
        </div>
        <div class="d-flex align-center" style="gap: 5px">
          <a-display-options-container v-if="density === 'default'">
            <div class="grey--text caption line-height-1">
              {{ $t("comparative") }}:
            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="kpi_mode === 'relative' ? 'secondary' : 'grey'"
                  :class="kpi_mode === 'relative' ? 'active' : ''"
                  @click="setKpiMode('relative')"
                >
                  mdi-percent-outline
                </v-icon>
              </template>
              <span>{{ $t("percentage") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="kpi_mode === 'absolute' ? 'secondary' : 'grey'"
                  :class="kpi_mode === 'absolute' ? 'active' : ''"
                  @click="setKpiMode('absolute')"
                >
                  mdi-counter
                </v-icon>
              </template>
              <span>{{ $t("absolute") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  :color="kpi_mode === 'hide_vs' ? 'secondary' : 'grey'"
                  :class="kpi_mode === 'hide_vs' ? 'active' : ''"
                  @click="setKpiMode('hide_vs')"
                >
                  mdi-circle-off-outline
                </v-icon>
              </template>
              <span>{{ $t("hide_vs") }}</span>
            </v-tooltip>
          </a-display-options-container>
          <a-display-options-container>
            <div class="grey--text caption line-height-1">
              {{ $t("view") }}:
            </div>
            <template>
              <v-tooltip
                bottom
                v-for="(group, index) in visibleStrategyGroups"
                :key="'group_' + index"
              >
                <template v-slot:activator="{ on, attrs }" v-if="group">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    small
                    :color="group.isActive ? 'secondary' : 'grey'"
                    @click="setViewGroup(group)"
                  >
                    {{ group.icon }}
                  </v-icon>
                </template>
                <span>
                  <template
                    v-if="
                      group.group.includes('pickup_') &&
                        group.group !== 'pickup_0'
                    "
                  >
                    {{ current_hotel.settings.pickup_spots[group.group] }}
                  </template>
                  <template v-else>
                    {{ $t(group.group) }}
                  </template>
                </span>
              </v-tooltip>
            </template>
          </a-display-options-container>
        </div>
      </div>
      <a-rms-strategy-day-table
        :configStrategyTable="configStrategyTable"
        :columns="strategyValues"
        :totalPeriod="totalPeriodValues"
        :days="days"
        :roomTypes="roomtype_types_mapped"
        :segments="segments"
        @getDayDetails="getDayDetails"
        :kpiMode="kpi_mode"
        :density="density"
      >
      </a-rms-strategy-day-table>
      <div
        class="day_details_mini secondary darken-2"
        v-if="detail_days.length > 0 && show_details_mini"
      >
        <v-card class="pa-0">
          <v-card-title class="pa-0">
            <v-btn
              icon
              color="grey"
              small
              @click="closeAllDaysDetails"
              class="mt-0"
              style="position: absolute; top: 10px; right: 15px;"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
            <v-btn
              icon
              color="grey"
              small
              @click="
                show_details_mini = false;
                show_details = true;
              "
              class="mt-0"
              style="position: absolute; top: 10px; right: 45px;"
            >
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
            <div class="secondary darken-3 pl-3" style="width:100%">
              <v-tabs
                background-color="transparent"
                center-active
                dark
                class="d-flex justify-start"
              >
                <v-tab
                  @click="
                    show_details_mini = false;
                    show_details = true;
                  "
                  v-for="(date, index) in detail_days"
                  :key="'tab_' + index"
                  class="pl-3 pr-10 text-capitalize"
                  >{{ getFriendlyDay(date) }}
                  <v-btn
                    icon
                    x-small
                    @click.stop="dropDayDetails(date)"
                    style="position:absolute; top: 15px; right: 10px;"
                    class="mt-0"
                  >
                    <v-icon x-small color="grey " style="margin-top: 2px;"
                      >mdi-close-circle-outline</v-icon
                    >
                  </v-btn>
                </v-tab>
              </v-tabs>
            </div>
          </v-card-title>
        </v-card>
      </div>
      <v-dialog
        v-model="show_details"
        style="margin-left:50px;"
        max-width="90%"
        class="pa-0"
        scrollable
        fullscreen
      >
        <v-card class="pa-0">
          <v-card-title class="pa-0">
            <v-btn
              icon
              color="grey"
              small
              @click="closeAllDaysDetails"
              class="mt-0"
              style="position: absolute; top: 10px; right: 15px;"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
            <v-btn
              icon
              color="grey"
              small
              @click="
                show_details_mini = true;
                show_details = false;
              "
              class="mt-0"
              style="position: absolute; top: 10px; right: 45px;"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
            <div
              class="secondary darken-3 pl-3 d-flex align-center"
              style="width:100%"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    dark
                    @click="navigateDay(-1)"
                    class="mr-1"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("previous_day") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    dark
                    @click="navigateDay(1)"
                    class="mr-2"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("next_day") }}</span>
              </v-tooltip>
              <v-tabs
                background-color="transparent"
                center-active
                dark
                class="d-flex justify-start"
                @click="show_details_mini = false"
                v-model="tab"
              >
                <v-tab
                  @click="show_details_mini = false"
                  v-for="(date, index) in detail_days"
                  :key="'tab_' + index"
                  class="pl-3 pr-10 text-capitalize"
                  >{{ getFriendlyDay(date) }}
                  <v-btn
                    icon
                    x-small
                    @click.stop="dropDayDetails(date)"
                    style="position:absolute; top: 15px; right: 10px;"
                    class="mt-0"
                  >
                    <v-icon x-small color="grey " style="margin-top: 2px;"
                      >mdi-close-circle-outline</v-icon
                    >
                  </v-btn>
                </v-tab>
              </v-tabs>
            </div>
          </v-card-title>
          <v-card-text class="px-0" style="overflow-x:hidden;">
            <v-row>
              <v-col cols="12" sm="3"></v-col>
              <v-col cols="12" sm="6">
                <v-list nav class="mb-0 pb-0">
                  <v-list-item-group
                    v-model="selectedTab"
                    color="secondary"
                    class="d-flex"
                  >
                    <v-list-item
                      class="mx-2 text-center mb-0 "
                      v-for="(item, i) in items"
                      :key="i"
                    >
                      <v-list-item-content class="ml-0 pr-3">
                        <v-icon class="mb-2">{{ item.icon }}</v-icon>
                        <v-list-item-title
                          class="text-uppercase"
                          v-text="$t(item.text)"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols="12" sm="3"></v-col>
              <v-col cols="12" class="pt-0">
                <div class="px-3">
                  <v-tabs-items v-model="tab">
                    <v-tab-item v-for="(date, i) in detail_days" :key="i">
                      <a-rms-day-price-evolution
                        v-if="selectedTab === 0"
                        :date="date"
                      ></a-rms-day-price-evolution>
                      <v-row v-if="selectedTab === 1">
                        <v-col cols="12" sm="12">
                          <a-rms-day-room-types
                            :date="date"
                            @close-dialog="dropDayDetails(date)"
                          ></a-rms-day-room-types>
                        </v-col>
                        <v-col cols="12" sm="6" class="pt-0">
                          <a-rms-day-general
                            :date="date"
                            :dense="true"
                          ></a-rms-day-general>
                        </v-col>
                        <v-col cols="12" sm="6" class="pt-0">
                          <v-row>
                            <v-col cols="12">
                              <a-rms-day-general-events
                                :date="date"
                                ref="a-rms-day-general-events"
                              >
                              </a-rms-day-general-events>
                            </v-col>
                            <v-col cols="12">
                              <a-rms-day-detail
                                :date="date"
                                ref="a-rms-day-detail"
                              ></a-rms-day-detail>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <a-rms-day-availability
                        :ref="'a-rms-day-availability_' + tab"
                        v-if="selectedTab === 2"
                        :date="date"
                        :max_days="7"
                      ></a-rms-day-availability>
                      <a-rms-day-comments
                        v-if="selectedTab === 3"
                        :date="date"
                      ></a-rms-day-comments>
                    </v-tab-item>
                  </v-tabs-items>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template v-slot:loading>
      <v-card>
        <v-card-text>
          <v-skeleton-loader
            v-for="i in 12"
            :key="i"
            type="card"
            height="70"
            class="elevation-0 mb-2"
          >
          </v-skeleton-loader>
        </v-card-text>
      </v-card>
    </template>
  </a-base-component>
</template>

<script>
import aBaseComponent from "@/components/aBaseComponent";
import aDisplayOptionsContainer from "@/components/aDisplayOptionsContainer";
import aRmsDayAvailability from "@/components/rms/aRmsDayAvailability";
import aRmsDayComments from "@/components/rms/aRmsDayComments.vue";
import aRmsDayDetail from "@/components/rms/aRmsDayDetail.vue";
import aRmsDayGeneral from "@/components/rms/aRmsDayGeneral.vue";
import aRmsDayGeneralEvents from "@/components/rms/aRmsDayGeneralEvents.vue";
import aRmsDayPriceEvolution from "@/components/rms/aRmsDayPriceEvolution.vue";
import aRmsDayRoomTypes from "@/components/rms/aRmsDayRoomTypes.vue";
import aRmsVsSelectorSingle from "@/components/rms/aRmsVsSelectorSingle";
import aRmsStrategyDayTable from "@/components/rms/axel/aRmsStrategyDayTable.vue";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import * as Utils from "@/utils.js";

const config_strategy_table = {
  "": {
    columns: {
      date: {}
    },
    icon: null
  },
  OTB: {
    columns: {
      occupancy: { kpi: "occupancy", block: "otb" },
      occupied: { kpi: "rn", block: "otb" },
      adr: { kpi: "adr", block: "otb" }
    },
    icon: "mdi-alarm-check"
  },
  cityMKD: {
    columns: {
      "MKD-14": { kpi: "city_demand", block: "pickup_4" },
      "MKD-7": { kpi: "city_demand", block: "pickup_3" },
      "MKD-3": { kpi: "city_demand", block: "pickup_2" },
      "MKD-Final": { kpi: "city_demand", block: "otb" }
    },
    icon: "mdi-home-city-outline"
  },
  sellpar: {
    columns: {
      sellpar: { kpi: "sellpar", block: "otb" },
      // sellpar_n: { kpi: "sellpar_n", block: "otb" } // El client ha demanat no veure aquest KPI
    },
    icon: "mdi-chart-timeline-variant",
    visibility: "sellpar"
  },
  rates: {
    columns: {
      current_rate: { kpi: "pvp", block: "otb" },
      rate_change: { kpi: "price", block: "pricing_strategy" },
      compset_min_price: { kpi: "compset_min_price", block: "otb" },
      compset_avg_min_price: { kpi: "compset_avg_min_price", block: "otb" },
      mlos: { kpi: "mlos", block: "otb" }
    },
    icon: "mdi-tag-multiple-outline"
  },
  roomtype: {
    columns: {
      // Se rellena dinamicamente
      sample: {
        kpi: "rn",
        block: "otb"
      }
    },
    icon: "mdi-sofa-outline"
  },
  segment: {
    columns: {
      // Se rellena dinamicamente
      sample: {
        kpi: "rn",
        block: "otb"
      }
    },
    icon: "mdi-hub-outline"
  },
  inventory: {
    columns: {
      out_of_order: { kpi: "locked", block: "otb" },
      tentative: { kpi: "tentative", block: "otb" },
      available: { kpi: "free", block: "otb", zero: true },
      available_pace: { kpi: "available_pace", block: "otb", zero: true }
    },
    icon: "mdi-ballot-outline"
  },
  revenue: {
    columns: {
      room_revenue: { kpi: "room_revenue", block: "otb" },
      room_revenue_other: { kpi: "othroom_revenue", block: "otb" },
      room_revenue_total: { kpi: "accommodation_revenue", block: "otb" }
    },
    icon: "mdi-cash-multiple"
  },
  pickup_0: {
    columns: {
      sold_rooms: { kpi: "rn", block: "pickup_0" },
      avg_price: { kpi: "adr", block: "pickup_0" },
      room_revenue: { kpi: "room_revenue", block: "pickup_0" }
    },
    icon: "mdi-numeric-0-circle-outline"
  },
  pickup_1: {
    columns: {
      sold_rooms: { kpi: "rn", block: "pickup_1" },
      avg_price: { kpi: "adr", block: "pickup_1" },
      room_revenue: { kpi: "room_revenue", block: "pickup_1" }
    },
    icon: "mdi-numeric-1-circle-outline"
  },
  pickup_2: {
    columns: {
      sold_rooms: { kpi: "rn", block: "pickup_2" },
      avg_price: { kpi: "adr", block: "pickup_2" },
      room_revenue: { kpi: "room_revenue", block: "pickup_2" }
    },
    icon: "mdi-numeric-3-circle-outline"
  },
  pickup_3: {
    columns: {
      sold_rooms: { kpi: "rn", block: "pickup_3" },
      avg_price: { kpi: "adr", block: "pickup_3" },
      room_revenue: { kpi: "room_revenue", block: "pickup_3" }
    },
    icon: "mdi-numeric-7-circle-outline"
  },
  pickup_4: {
    columns: {
      sold_rooms: { kpi: "rn", block: "pickup_4" },
      avg_price: { kpi: "adr", block: "pickup_4" },
      room_revenue: { kpi: "room_revenue", block: "pickup_4" }
    },
    icon: "mdi-dots-vertical-circle-outline"
  }
};

export default {
  name: "a-rms-strategy-weeks",
  components: {
    aBaseComponent,
    aRmsDayAvailability,
    aDisplayOptionsContainer,
    aRmsDayGeneral,
    aRmsDayRoomTypes,
    aRmsDayComments,
    aRmsDayPriceEvolution,
    aRmsDayDetail,
    aRmsDayGeneralEvents,
    aRmsStrategyDayTable,
    aRmsVsSelectorSingle
  },
  props: {
    event_period: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    title: "",
    subscribed_modules: [
      "rate_available_rate_extractions",
      "rms_all_kpis_daily_dimension",
      "rms_all_kpis_period_dimension",
      "rms_pvp_mlos_changes_daily",
      "segmentschannels_segments",
      "segmentschannels_segment_channels",
      "segmentschannels_market_segments",
      "roomtype_types_mapped",
      "rms_daily_suggestions",
      "pricingstrategy_rules",
      "pricingstrategy_rule_types",
      "pricingstrategy_strategies",
      "pricingstrategy_strategy_rates",
      "pricingstrategy_strategy_room_types"
    ],
    subscribed_modules_footer: ["rms_roomtype_availability"],
    current_visible_week_index: 0,
    item_height: 300,
    table_height: "calc(100% - 200px)",
    edit_event_period: [],
    show_range_selector: false,
    picker_date: null,
    picker_date2: null,
    event_selected: null,
    detail_days: [],
    show_details: false,
    show_details_mini: false,
    row: null,
    week: null,
    selectedTab: 0,
    items: [
      { text: "price_evolution", icon: "mdi-chart-timeline-variant" },
      { text: "general", icon: "mdi-information-outline" },
      { text: "availability", icon: "mdi-select-compare" },
      { text: "comments", icon: "mdi-comment-multiple-outline" }
    ],
    tab: 0,
    kpi_mode: "relative",
    density: "default",
    strategy_groups_icons: Object.keys(config_strategy_table)
      .map(group => {
        return {
          group: group,
          icon: config_strategy_table[group].icon,
          isActive: true
        };
      })
      .filter(g => g.group !== "")
  }),
  watch: {
    picker_date(newVal, oldVal) {
      if (newVal !== oldVal) {
        let d = Vue.moment(newVal + "-01").add(1, "month");
        this.picker_date2 = d.format("YYYY-MM");
      }
    },
    picker_date2(newVal, oldVal) {
      if (newVal !== oldVal) {
        let d = Vue.moment(newVal + "-01").subtract(1, "month");
        this.picker_date = d.format("YYYY-MM");
      }
    },
    event_selected(newVal) {
      if (newVal) {
        let event = this.events.find(e => e.id === newVal);
        this.setPeriod([event.start_date, event.end_date]);
      }
    },
    detail_days: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          let date = newVal[this.tab];
          if (!this.show_details_mini) this.show_details = true;
          this.getRates();
          this.$store.dispatch("setRateDateToCompare", date);
          this.setAvailabilityRange(date);
        } else {
          // this.show_details_mini = false;
          this.show_details = false;
        }
      }
    },
    tab(newVal, oldVal) {
      if (newVal >= 0) {
        let date = this.detail_days[newVal];
        this.getRates();
        this.$store.dispatch("setRateDateToCompare", date);
        this.setAvailabilityRange(date);
      }
    },
    current_hotel() {
      this.getHotelComments();
    },
    user_settings() {
      if (this.user_settings) {
        this.setInitFilters();
      }
    }
  },
  methods: {
    saveUserSettings() {
      // Protegeix i assegura que els valors existeixen
      if (!this.current_user) this.current_user = {};
      if (!this.current_user.settings) this.current_user.settings = {};
      if (!this.current_user.settings["rms_strategy"])
        this.current_user.settings["rms_strategy"] = {};
      if (!this.current_user.settings["rms_strategy"]["0"])
        this.current_user.settings["rms_strategy"]["0"] = {};

      // Copiem els settings actuals per evitar mutacions inesperades
      let rmsStrategy = { ...this.current_user.settings["rms_strategy"]["0"] };

      rmsStrategy["values_vs"] = this.strategy_vs_spot;
      rmsStrategy["comparative"] = this.kpi_mode;
      rmsStrategy["density"] = this.density;
      rmsStrategy["strategy_groups_icons"] = Array.isArray(
        this.strategy_groups_icons
      )
        ? this.strategy_groups_icons.map(g => ({ ...g }))
        : [];

      // Actualitza les dades sobre l'objecte inicial per consistència local
      this.current_user.settings["rms_strategy"]["0"] = rmsStrategy;

      this.$store.dispatch("setRmsStrategyUserSettings", {
        settings: rmsStrategy,
        hotel_id: "0"
      });
    },
    updateVs(vs) {
      this.$store.dispatch("setRmsStrategyVsSpot", vs);
      this.saveUserSettings();
    },
    setKpiMode(mode) {
      this.kpi_mode = mode;
      this.saveUserSettings();
    },
    setDensity(mode) {
      this.density = mode;
      this.saveUserSettings();
    },
    setViewGroup(group) {
      this.strategy_groups_icons.find(
        g => g.group === group.group
      ).isActive = !group.isActive;
      this.saveUserSettings();
    },
    setInitFilters() {
      if (
        this.user_settings &&
        this.user_settings.rms_strategy &&
        this.user_settings.rms_strategy["0"]
      ) {
        let user_data = this.user_settings.rms_strategy["0"];

        if (user_data.values_vs) {
          this.$store.dispatch("setRmsStrategyVsSpot", user_data.values_vs);
        }
        if (user_data.comparative) {
          this.kpi_mode = user_data.comparative;
        }
        if (user_data.density) {
          this.density = user_data.density;
        }
        if (user_data.strategy_groups_icons) {
          // recorremos el array y buscamos el grupo para cambiar el isActive
          for (let group of user_data.strategy_groups_icons) {
            const group_icon = this.strategy_groups_icons.find(
              g => g.group === group.group
            );
            if (group_icon) {
              group_icon.isActive = group.isActive;
            }
          }
        }
      }
    },
    setAvailabilityRange(date) {
      // Reload availability dates
      let init_date_moment = Vue.moment(date).subtract(3, "days");
      this.availability_from = init_date_moment.format("YYYY-MM-DD");
      this.availability_to = init_date_moment
        .add(6, "days")
        .format("YYYY-MM-DD");
      this.$store.dispatch("fetchRmsRoomtypeAvailability");
    },
    getRates() {
      this.$store.dispatch("setRateFilters", {
        extraction_id: this.available_rate_import_ids[0],
        vs_id: this.available_rate_import_ids[1],
        pax: 2,
        childs: 0,
        regime: [],
        cancel_policy: [],
        genius:
          this.current_hotel && this.current_hotel.settings
            ? this.current_hotel.settings.booking_genius_enabled || false
            : false,
        mobile_device:
          this.current_hotel && this.current_hotel.settings
            ? this.current_hotel.settings.booking_mobile_enabled || false
            : false
      });
    },
    closeAllDaysDetails() {
      this.detail_days = [];
    },
    getDayDetails(date) {
      if (!this.detail_days.includes(date)) {
        this.detail_days.push(date);
      }
      this.tab = this.detail_days.indexOf(date);
    },
    navigateDay(direction) {
      if (this.detail_days.length === 0) return;
      let currentIndex = this.tab >= 0 ? this.tab : 0;
      let currentDate = this.detail_days[currentIndex];
      if (!currentDate) return;
      let newDate = Vue.moment(currentDate)
        .add(direction, "days")
        .format("YYYY-MM-DD");
      if (this.detail_days.includes(newDate)) {
        this.tab = this.detail_days.indexOf(newDate);
        return;
      }
      this.$set(this.detail_days, currentIndex, newDate);
      this.tab = currentIndex;
    },
    dropDayDetails(date) {
      if (this.detail_days.includes(date)) {
        let index = this.detail_days.indexOf(date);
        if (index !== -1) {
          this.detail_days.splice(index, 1);
        }
      }
    },
    setPeriod(v) {
      this.edit_event_period = JSON.parse(JSON.stringify(v));
      this.picker_date = Vue.moment(v[0]).format("YYYY-MM");
    },
    getFriendlyDay(date) {
      return date ? Utils.getFriendlyDay(date) : "";
    },
    setDefault() {
      // Scroll event control
      setTimeout(() => {
        const scroller = document.getElementById("weeks_table");
        if (scroller) {
          scroller.addEventListener("scroll", e => {
            this.current_visible_week_index = parseInt(
              e.target.scrollTop / this.item_height
            );
          });
        }
      }, 1000);
    },
    async getHotelComments() {
      await this.$store
        .dispatch("getHotelComments", {
          hotel_id: this.current_hotel.id
        })
        .catch(() => {
          Utils.showError(this, "something_went_wrong");
        });
    }
  },
  computed: {
    days() {
      let days = [];
      // Build an array of days starting on initial event_period and ending in end date period
      let init_date = this.event_period[0];
      let end_date = this.event_period[1];
      let current_date = init_date;
      while (current_date <= end_date) {
        days.push(current_date);
        current_date = Vue.moment(current_date)
          .add(1, "days")
          .format("YYYY-MM-DD");
      }
      return days;
    },
    strategyValues() {
      // return strategy_data;
      return this.rms.all_kpis_daily_dimension;
    },
    totalPeriodValues() {
      return this.rms.all_kpis_period_dimension;
    },
    minSoldRoomsPickup4() {
      return Object.values(this.rms.all_kpis_daily_dimension).reduce(
        (acc, cur) => {
          const pickup4 = cur && cur.pickup_4 ? cur.pickup_4.rn : undefined;
          return pickup4 !== undefined
            ? Math.min(acc ? acc : pickup4, pickup4)
            : acc
            ? acc
            : 0;
        },
        null
      );
    },
    maxSoldRoomsPickup4() {
      return Object.values(this.rms.all_kpis_daily_dimension).reduce(
        (acc, cur) => {
          const pickup4 = cur && cur.pickup_4 ? cur.pickup_4.rn : undefined;
          return pickup4 !== undefined
            ? Math.max(acc ? acc : pickup4, pickup4)
            : acc
            ? acc
            : 0;
        },
        null
      );
    },
    visibleStrategyGroups() {
      return this.strategy_groups_icons.filter(g => {
        return config_strategy_table[g.group].visibility
          ? this.has_permission(config_strategy_table[g.group].visibility)
          : true;
      });
    },
    configStrategyTable() {
      return {
        "": config_strategy_table[""],
        ...this.visibleStrategyGroups.reduce((acc, cur) => {
          if (cur.isActive) {
            acc[cur.group] = config_strategy_table[cur.group];
            if (cur.group === "roomtype") {
              acc[cur.group].columns = this.roomtype_types_mapped.reduce(
                (accRoomType, curRoomType) => {
                  accRoomType[curRoomType.code] = {
                    kpi: "rn",
                    block: "otb",
                    limit: curRoomType.available_rooms
                  };
                  return accRoomType;
                },
                {}
              );
            } else if (cur.group === "segment") {
              acc[cur.group].columns = this.segments.reduce(
                (accSegment, curSegment) => {
                  accSegment[curSegment.code] = {
                    kpi: "rn",
                    block: "otb"
                  };
                  return accSegment;
                },
                {}
              );
            } else if (cur.group.startsWith("pickup_")) {
              for (let col of Object.keys(acc[cur.group].columns)) {
                acc[cur.group].columns[col].limit = 0;
                if (cur.group === "pickup_4" && col === "sold_rooms") {
                  acc[cur.group].columns[col].min = this.minSoldRoomsPickup4;
                  acc[cur.group].columns[col].max = this.maxSoldRoomsPickup4;
                }
              }
            } else if (cur.group === "inventory") {
              const limit = Math.round(
                this.roomtype_types_mapped.reduce(
                  (accRoomType, curRoomType) => {
                    return accRoomType
                      ? accRoomType + curRoomType.available_rooms
                      : curRoomType.available_rooms;
                  },
                  0
                ) * 0.2
              );
              acc[cur.group].columns["available"].limit = limit;
              acc[cur.group].columns["available_pace"].limit = limit;
            }

            // If density is compact, we hide columns
            if (this.density === "compact") {
              if (cur.group === "OTB") {
                acc[cur.group].columns["occupied"].hidden = true;
              } else if (cur.group === "cityMKD") {
                acc[cur.group].columns["MKD-14"].hidden = true;
                acc[cur.group].columns["MKD-7"].hidden = true;
                acc[cur.group].columns["MKD-3"].hidden = true;
              } else if (cur.group === "rates") {
                acc[cur.group].columns["compset_min_price"].hidden = true;
                acc[cur.group].columns["mlos"].hidden = true;
              } else if (cur.group === "inventory") {
                acc[cur.group].columns["out_of_order"].hidden = true;
                acc[cur.group].columns["tentative"].hidden = true;
              } else if (cur.group === "revenue") {
                acc[cur.group].columns["room_revenue"].hidden = true;
                acc[cur.group].columns["room_revenue_other"].hidden = true;
              } else if (cur.group === "pickup_0") {
                acc[cur.group].columns["room_revenue"].hidden = true;
              } else if (cur.group === "pickup_1") {
                acc[cur.group].columns["room_revenue"].hidden = true;
              } else if (cur.group === "pickup_2") {
                acc[cur.group].columns["room_revenue"].hidden = true;
              } else if (cur.group === "pickup_3") {
                acc[cur.group].columns["room_revenue"].hidden = true;
              } else if (cur.group === "pickup_4") {
                acc[cur.group].columns["room_revenue"].hidden = true;
              }
            } else {
              for (let col of Object.keys(acc[cur.group].columns)) {
                acc[cur.group].columns[col].hidden = false;
              }
            }
          }
          return acc;
        }, {})
      };
    },
    availability_from: {
      get() {
        return this.$store.state.rms.availability_from;
      },
      set(value) {
        this.$store.dispatch("setAvailabilityFrom", value);
      }
    },
    availability_to: {
      get() {
        return this.$store.state.rms.availability_to;
      },
      set(value) {
        this.$store.dispatch("setAvailabilityTo", value);
      }
    },
    available_rate_import_ids() {
      // In this.available_rate_extractions we have a list of [{date: "2020-01-01", extractions: {id: 1234, time: "12:01:01"}}, {...}]
      // From there we take a list of ids to make an easy validation
      let ids = [];
      if (this.available_rate_extractions) {
        ids = this.available_rate_extractions.reduce(
          (ids, cur) => ids.concat(cur.extractions.map(imp => imp.id)),
          []
        );
      }
      return ids;
    },
    nextHotelEvents() {
      return Array.isArray(this.events)
        ? this.events
            .filter(
              e =>
                (e.impact === "high" ||
                  e.impact === "very_high" ||
                  e.impact === "exceptional") &&
                Vue.moment(e.start_date).isAfter(Vue.moment())
            )
            .slice(0, 5)
            .map(e => {
              return {
                type: e.type,
                impact: e.impact,
                text: e.name,
                value: [e.start_date, e.end_date]
              };
            })
        : [];
    },
    events() {
      return this.calendar_store.hotel_events;
    },
    next_available_periods() {
      let next_available_periods = [
        {
          text: "next_30_days",
          type: "period",
          impact: "high",
          value: [
            Vue.moment().format("YYYY-MM-DD"),
            Vue.moment()
              .add(30, "days")
              .format("YYYY-MM-DD")
          ]
        },
        {
          text: "next_7_days",
          type: "period",
          impact: "high",
          value: [
            Vue.moment().format("YYYY-MM-DD"),
            Vue.moment()
              .add(7, "days")
              .format("YYYY-MM-DD")
          ]
        },
        {
          text: "next_15_days",
          type: "period",
          impact: "high",
          value: [
            Vue.moment().format("YYYY-MM-DD"),
            Vue.moment()
              .add(15, "days")
              .format("YYYY-MM-DD")
          ]
        },

        {
          text: "this_month",
          type: "period",
          impact: "high",
          value: [
            Vue.moment()
              .startOf("month")
              .format("YYYY-MM-DD"),
            Vue.moment()
              .endOf("month")
              .format("YYYY-MM-DD")
          ]
        },
        {
          text: "next_month",
          type: "period",
          impact: "high",
          value: [
            Vue.moment()
              .add(1, "month")
              .startOf("month")
              .format("YYYY-MM-DD"),
            Vue.moment()
              .add(1, "month")
              .endOf("month")
              .format("YYYY-MM-DD")
          ]
        },
        {
          text: "this_week",
          type: "period",
          impact: "high",
          value: [
            Vue.moment()
              .startOf("week")
              .format("YYYY-MM-DD"),
            Vue.moment()
              .endOf("week")
              .format("YYYY-MM-DD")
          ]
        },
        {
          text: "next_week",
          type: "period",
          impact: "high",
          value: [
            Vue.moment()
              .add(1, "week")
              .startOf("week")
              .format("YYYY-MM-DD"),
            Vue.moment()
              .add(1, "week")
              .endOf("week")
              .format("YYYY-MM-DD")
          ]
        }
      ];
      let periods = next_available_periods.concat(this.nextHotelEvents);
      for (let period of periods) {
        period.text = this.$t(period.text);
        period.active =
          period.value[0] === this.edit_event_period[0] &&
          period.value[1] === this.edit_event_period[1];
      }
      return periods;
    },
    init_date() {
      return this.event_period[0];
    },
    end_date() {
      return this.event_period[1];
    },
    year() {
      return Vue.moment(this.init_date).format("YYYY");
    },
    weeks_by_year() {
      let weeks_by_year = {};
      let init_year = parseInt(Vue.moment().format("YYYY"));
      weeks_by_year[init_year] = Utils.getYearlyCalendar(init_year);
      weeks_by_year[init_year + 1] = Utils.getYearlyCalendar(init_year + 1);
      return weeks_by_year;
    },
    all_weeks() {
      let weeks = [];
      for (let y in this.weeks_by_year) {
        for (let m in this.weeks_by_year[y]) {
          for (let w in this.weeks_by_year[y][m]) {
            let week = this.weeks_by_year[y][m][w];
            weeks.push(this.weeks_by_year[y][m][w]);
          }
        }
      }
      return weeks;
    },
    current_visible_week() {
      return this.all_weeks[this.current_visible_week_index];
    },
    marketsegments_mode() {
      return (
        this.current_hotel &&
        this.current_hotel.settings &&
        !!this.current_hotel.settings.marketsegments_in_day_kpis
      );
    },
    segments() {
      return this.marketsegments_mode
        ? this.segmentschannels.market_segments.filter(s => !!s.visible)
        : this.segmentschannels.segments;
    },
    ...mapState({
      rms: state => state.rms,
      hotelsdot: state => state.hotelsdot,
      calendar_store: state => state.calendar,
      available_rate_extractions: state =>
        state.rate.available_rate_extractions,
      roomtype_types_mapped: state => state.roomtype.types_mapped,
      segmentschannels: state => state.segmentschannels,
      strategy_vs_spot: state => state.rms.strategy_vs_spot
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      current_user: "current_user",
      yearly_calendar: "getYearlyCalendar",
      opened_days: "opened_days",
      getDayEvents: "getDayEvents",
      available_years: "getHotelAvailableYears",
      user_settings: "getUserSettings",
      has_permission: "has_permission"
    })
  },
  mounted() {
    this.setDefault();
    this.getRates();
    if (this.current_hotel) {
      this.getHotelComments();
    }
    if (this.user_settings) {
      this.setInitFilters();
    }
  }
};
</script>
<style lang="scss">
.v-list--dense .v-list-item {
  min-height: 33px;
}
.v-date-picker-title__date {
  font-size: 16px;
}

.cols7 {
  width: calc(100% / 7);
  max-width: calc(100% / 7);
  flex-basis: calc(100% / 7);
}

.a-rms-strategy-weeks-header {
  .v-icon.active::after {
    border-radius: 0;
    bottom: -8px;
    top: auto;
    height: 3px;
    opacity: 1;
    transform: none;
  }
  .a-rms-vs-selector-single {
    button {
      height: 31px !important;
    }
  }
}

$height: 19px;
.a-rms-day {
  font-size: 11px;
  line-height: height;
  text-align: right;
  &:focus::before {
    background: white;
  }

  .a-rms-day-row-day {
    height: $height;
    font-weight: 600;
    text-transform: uppercase;
    color: #444444;
    letter-spacing: -0.5px;
  }
  .a-rms-day-row-header {
    font-size: 11px;
    font-weight: 500;
    color: #666666;
    text-transform: uppercase;
    height: $height;
    overflow: hidden;
    letter-spacing: -0.5px;
  }
  .a-rms-day-row {
    height: $height;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  .a-rms-day-row-resume {
    height: $height;
    font-weight: 600;
    overflow: hidden;
  }
}
.day_details_mini {
  position: fixed;
  width: 90%;
  bottom: 20px;
  border-radius: 15px;
  overflow: hidden;
  z-index: 20;
}
</style>
